import { useTranslation } from 'react-i18next';

import { DEFAULT_APP_STORE_URL } from '../../../constants/appInfo';
import { Images } from '../../../constants/images';
import { SvgIcon } from '../SVGIcon';

import styles from './InvitationStepsButtonGroup.module.css';
type Props = {
  onPressAccept: () => void;
};

export const InvitationStepsButtonGroup = (props: Props) => {
  const { onPressAccept } = props;
  const { t } = useTranslation();
  // const onPressDownload = () => {
  //   window.open(DEFAULT_APP_STORE_URL, '_blank');
  // };

  return (
    <div className={styles.stepsContainer}>
      <div className={styles.stepItem}>
        <p className={styles.stepInfo}>{t('Step 1: Download JOYAJOY')}</p>
        <a
          className={styles.appStoreButton}
          href={DEFAULT_APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={Images.DownloadFromAppStore}
            alt="Download From AppStore"
            style={{ height: '100%', width: 'auto' }}
          />
        </a>
        {/* <button className={styles.button} onClick={onPressDownload}>
          {t('Download')}
          <SvgIcon
            name={'Arrow'}
            className={styles.arrowIcon}
            width={20}
            height={20}
            stroke={'#ffffff'}
          />
        </button> */}
      </div>
      <div className={styles.stepItem}>
        <p className={styles.stepInfo}>
          {t('Step 2: Click "Accept Invitation" button')}
        </p>
        <button className={styles.button} onClick={onPressAccept}>
          {t('Accept Invitation')}
          <SvgIcon
            name={'Arrow'}
            className={styles.arrowIcon}
            width={20}
            height={20}
            stroke={'#ffffff'}
          />
        </button>
      </div>
    </div>
  );
};
